import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import BaseModal from "../../components/BaseModal";
import BaseButton from "../../components/BaseButton";
import { MODAL_TYPES } from "../../utils/emitter";
import useModalActions from "../../hooks/useModalActions";
import ROUTES from "../../utils/routes";
import Game from "../../store/Game";
import PersonalAccount from "../../store/PersonalAccount";
import { CURRENT_GAME_KEY } from "../../utils/constants";
import "./style.scss";

// «Твой партнер разблокировал 57 карточек и приглашает тебя» (ТЗ п.7.5):
// приходит по socket extended-57-unlocked (авто-доставка партнёру по коннекту).
export default function PartnerUnlocked57Modal() {
  const [payload, setPayload] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { closeModal } = useModalActions();

  const startTest = () => {
    closeModal(MODAL_TYPES.PARTNER_UNLOCKED_57);
    // переключаем контекст на игру события: попап мог прийти, когда активна другая
    // игра — иначе ответы +57 ушли бы не туда (games свежие: bridge обновил их до показа)
    const eventGame = PersonalAccount.games?.find(
      (game) => game.id === payload?.gameId
    );
    if (eventGame) {
      Game.setGame(eventGame);
      localStorage.setItem(CURRENT_GAME_KEY, JSON.stringify(eventGame));
    }
    // item 6: вход в +57 через страницу инструкции
    navigate(ROUTES.EXTENDED_57_INSTRUCTION_PAGE, {
      state: { gameId: payload?.gameId },
    });
  };

  return (
    <BaseModal
      className="partner-unlocked57-modal"
      eventTypeModal={MODAL_TYPES.PARTNER_UNLOCKED_57}
      onPayload={(data) => data && setPayload(data)}
      title={t("extended57.partner_unlocked.title")}
      description={t("extended57.partner_unlocked.text")}
    >
      <BaseButton onClick={startTest}>
        {t("extended57.start_test_btn")}
      </BaseButton>
    </BaseModal>
  );
}
